export default __webpack_public_path__ + "static/media/virtual-reality.47c881f6.png";